const HTTPCODE = ' | HTTP状态码: '
const URL = 'URL地址: '
const MSG = ' | 信息: '
const server = {
  // 输出axios的常用信息
  logger: {
    error(resp) {
      let status = HTTPCODE + resp.status
      let url = URL + resp.request.responseURL
      let msg = MSG + JSON.stringify(resp.data)
      console.log(url + status + msg)
    },
    info(resp) {
      let status = HTTPCODE + resp.status
      let url = URL + resp.request.responseURL
      console.log(url + status)
    },
    debug(resp) {
      let status = HTTPCODE + resp.status
      let url = URL + resp.request.responseURL
      if (resp.status === 200) {
        let datacode = ' | 后端响应码: '
        if (resp.data['state'] !== 0) {
          datacode = datacode + resp.data['state'] + '(' + resp.data['msg'] + ')'
        } else {
          datacode += resp.data['state']
        }
        console.log(url + status + datacode)
        return Number.MIN_SAFE_INTEGER
      }
      let msg = MSG + JSON.stringify(resp.data)
      console.log(url + status + msg)
    }
  }
}

export default server



// WEBPACK FOOTER //
// ./src/server/index.js